<div class="main-wrapper">
    <div class="title-row">
        <h1>Data Table In Firsetore</h1>
    </div>

    <table>
        <thead>
            <tr>
                <th>Firecloud Id</th>
                <th>Name</th>
                <th>Date</th>
                <th>Time</th>
                <th>Message</th>
            </tr>
        </thead>
       <tbody>
           <tr *ngFor = "let item of countData">
                <td><p>{{item.key}}</p></td>
                <td><p>{{item.value.name}}</p></td>
                <td><p>{{item.value.date}}</p></td>
                <td><p>{{item.value.time}}</p></td>
                <td><p>{{item.value.message}}</p></td>
           </tr>
       </tbody>
    </table>
</div>